
import Upload from '@/components/shared/Upload.vue'
import FacialAccessForm from "@/components/views/invitations/FacialAccessForm.vue";


export default [
  // {path: '/', component: Upload, name: 'root'},
  {path: '/', component: FacialAccessForm, name: 'root'},
]
